export interface ConnectionUrl {
  prefix: string;
  workspace: string;
  suffix: string;
  url: string;
}

export const connectionUrl = (
  workspace: string | undefined,
  environment: string | undefined = import.meta.env?.VITE_SERVICE_ENVIRONMENT,
): ConnectionUrl | null => {
  if (!workspace) return null;
  const prefix = "https://";
  const suffix = `.light-cycle${environment === undefined || environment === "local" ? "-local" : environment}.changeengine.com/mcp`;
  return { prefix, workspace, suffix, url: `${prefix}${workspace}${suffix}` };
};
